import { ExpedienteSearchPage as SharedExpedienteSearchPage } from "@tribunalea/ui";
import { useApi } from "../App.jsx";

export function ExpedienteSearchPage() {
  const api = useApi();
  return <SharedExpedienteSearchPage api={api} />;
}
